/**
 * Can this browser create a WebGL context? Checked once and cached.
 *
 * The particle field is gated on "desktop + motion OK"; without this check a
 * browser with WebGL disabled/unavailable (headless crawlers, SEO scanners,
 * locked-down or GPU-blocklisted machines) mounted the Three.js canvas anyway and
 * threw "Error creating WebGL context". Those visitors now get the same static
 * fallbacks phones and reduced-motion users already see. Real browsers with WebGL
 * are unaffected.
 */
let cached: boolean | null = null

export function hasWebGL(): boolean {
  if (cached !== null) return cached
  if (typeof document === 'undefined') return false
  try {
    const canvas = document.createElement('canvas')
    const gl = (canvas.getContext('webgl2') || canvas.getContext('webgl')) as WebGLRenderingContext | null
    cached = !!gl
    // Free the probe context immediately (browsers cap live contexts per page).
    gl?.getExtension('WEBGL_lose_context')?.loseContext()
  } catch {
    cached = false
  }
  if (!cached) document.documentElement.setAttribute('data-webgl', 'off')
  return cached
}
